import React, { useEffect, useState } from 'react';
import { Events, publish, subscribe } from '@conversion-cloud-widget/pubsub';
import { Launcher, LauncherSize, ModuleBarSkins } from '@conversion-cloud-widget/UI';
import StepRouter from './StepRouter';
import Icon from './Icon';

const Bar = ({ backgroundColor, chatBot, companyId, mode, order, size, skin, textColor, xPosition, yPosition }) => {
    const [hide, setHide] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [launched, setLaunched] = useState(undefined);

    const { call_to_action } = chatBot.chatbot;
    const { questions } = chatBot.questions;

    const handleLaunch = (item, modal) => {
        setIsModal(modal || false);
        setLaunched(item);

        publish(Events.GA_EVENT, {
            action: `Module Opened`,
            module: process.env.MODULE_NAME,
            category: 'TCC'
        });

        publish(Events.MODULE_OPENED, {
            module: process.env.MODULE_NAME,
            companyId: companyId,
            data: { ...item }
        });
    };

    useEffect(() => {
        // Add a property to the window to let the DOM know that the module bar is loaded.
        // This allows the container to open modules based on querystring params and
        // ensure that the module is loaded so that it can open.
        window[`${process.env.MODULE_NAME}_BAR`] = `${process.env.MODULE_NAME}_BAR`;

        subscribe(Events.MODULE_OPENED, () => {
            setHide(true);
        });

        subscribe(Events.MODULE_CLOSED, () => {
            setLaunched(undefined);
            setHide(false);
        });

        subscribe(Events.OPEN_MODULE, payload => {
            if (payload.module === process.env.MODULE_NAME) {
                handleLaunch(chatBot, payload.asModal);
            }
        });
    }, [hide, launched]);

    return questions ? (
        <>
            <StepRouter
                backgroundColor={backgroundColor}
                companyId={companyId}
                chatBot={launched}
                isModal={isModal}
                size={size}
                textColor={textColor}
                xPosition={xPosition}
                yPosition={yPosition}
            />
            <Launcher
                backgroundColor={backgroundColor}
                height={LauncherSize[size].height}
                icon={
                    <Icon
                        fill={
                            skin === ModuleBarSkins.WALLET
                                ? backgroundColor
                                : mode === 'dark'
                                ? textColor
                                : backgroundColor
                        }
                    />
                }
                item={chatBot}
                key={companyId}
                mode={mode}
                onClick={handleLaunch}
                onKeyDown={handleLaunch}
                order={order}
                size={size}
                skin={skin}
                textColor={textColor}
                title={call_to_action || 'FAQ'}
                width={LauncherSize[size].width}
            />
        </>
    ) : (
        <></>
    );
};

export default Bar;
